export default "__VITE_ASSET__B7z$cLiB__"